import request from '@/api/base'

const getRegionList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/estate/regionList', params)
}
const getBuildingList = (params) => {
  // params.mockApi = true
  return request.post('/portal/estate/buildInfoNull', params)
}
const getFloorList = (params) => {
  return request.post('/portal/estate/floorInfo', params)
}
const getRoomList = (params) => {
  return request.post('/portal/room/queryList', params)
}
// 获取楼栋设置中的区域下拉框列表
const getRegionName = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.get('/portal/estate/regionInfo', params)
}

// 获取房源楼栋设置列表页
const getBuildSettingData = (params) => {
  return request.post('/portal/estate/listBuild', params)
}

// 检查房间是否能合并
const isMerger = (params) => {
  return request.post('/portal/room/isMerger', params)
}
// 租控图首页列表及图表数据接口
const staticRoomStatusByRegionId = (params) => {
  // params.test = true
  return request.post('/portal/room/staticRoomStatusByRegionId', params)
}
// 通过楼栋id获得楼栋房间情况
const listRoomStatusByBuildId = (params) => {
  return request.post('/portal/estate/listRoomStatusByBuildId', params)
}
const getAllStructuredEstateInfo = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/room/getAllStructuredEstateInfo', params)
}
// 通过房间id获得房间详情以便拆分
const gethouseBillData = (params) => {
  return request.post('/portal/room/queryList/map', params)
}
// 拆分房间台账中的房间
const splitBillRomm = (params) => {
  return request.post('/portal/room/splite', params)
}
// 合并房间台账中的房间
const mergeBillRomm = (params) => {
  return request.post('/portal/room/merge', params)
}
// 通过房间编码查询到房间基础信息
const queryRoomInfo = (params) => {
  return request.post('/portal/room/queryRoomInfo', params)
}

// 获取楼栋设置中的楼栋下拉框列表
const getBuildName = (params) => {
  return request.post('/portal/estate/buildInfo', params)
}
// 获取拆分合并详情信息
const getSplitMergeRoom = (params) => {
  return request.get(`/portal/room/split-merge/${params.roomId}`)
}

// 2.报表统计 租赁情况统计表
const getBuildRentalInfoRequestVO = (params) => {
  return request.post('/portal/statistical/getBuildRentalInfoRequestVO', params)
}
// 3.报表统计 获取房产信息统计表
const getRoomStatisticalInfoVO = (params) => {
  return request.post('/portal/statistical/getRoomStatisticalInfoVO', params)
}
// 4.报表统计 公寓入住信息报表
const rentalStatisticalInfoVO = (params) => {
  return request.post('/portal/statistical/rentalStatisticalInfoVO', params)
}
// 5.报表统计 公寓入住企业统计报表
const rentalCompanyStatisticalInfoVO = (params) => {
  return request.post('/portal/statistical/rentalCompanyStatisticalInfoVO', params)
}
// 6.报表统计 公寓收入情况统计表
const getApartmentInComeStatisticalVO = (params) => {
  return request.post('/portal/statistical/getApartmentInComeStatisticalVO', params)
}

// 7.获取合同归档的数据
const getContractFiling = (params) => {
  return request.post('/portal/contract/queryContractPageByCondition', params)
}

// 获取落地企业
const getLandingEnterprisesList = (params) => {
  return request.post('/portal/companyBook/queryCommercialFloorList', params)
}
// 删除落地企业
const deletLandingEnterprisesList = (params) => {
  return request.post('/portal/companyBook/deleteCompanyBook', params)
}
// 查询落地企业详情
const getLandingEnterprisesDetail = (params) => {
  return request.post('/portal/companyBook/queryCommercialFloorInfo', params)
}
// 修改企业信息
const updateLandingEnterprisesDetail = (params) => {
  return request.post('/portal/companyBook/updateCommercialFloor', params)
}
// 添加企业信息
const addLandingEnterprisesDetail = (params) => {
  return request.post('/portal/companyBook/addCommercialFloor', params)
}
//  获取项目信息
const getProjectList = (params) => {
  return request.post('/portal/commercialProject/queryCommercialProjectInfoList', params)
}

// 落地方式申请/修改
const saveLandingWay = (params) => {
  return request.post('/portal/commercialFloor/floorType/save', params)
}

// 校验是否已在商机信息菜单中维护该企业
const checkCommercialCompany = (params) => {
  return request.post('/portal/commercialCompany/checkCommercialCompany', params)
}

// 删除落地方式
const delLandingWay = (params) => {
  return request.post('/portal/commercialFloor/floorType/delete', params)
}
// 落地方式审批
const submitLandingWay = (params) => {
  return request.post('/portal/commercialFloor/floorType/submit', params)
}
export default {
  getSplitMergeRoom,
  getBuildName,
  getRegionList,
  getBuildingList,
  getFloorList,
  getRoomList,
  mergeBillRomm,
  getApartmentInComeStatisticalVO,
  rentalStatisticalInfoVO,
  rentalCompanyStatisticalInfoVO,
  listRoomStatusByBuildId,
  gethouseBillData,
  getRoomStatisticalInfoVO,
  splitBillRomm,
  getBuildRentalInfoRequestVO,
  queryRoomInfo,
  staticRoomStatusByRegionId,
  getBuildSettingData,
  isMerger,
  getRegionName,
  getAllStructuredEstateInfo,
  getContractFiling,
  getLandingEnterprisesList,
  deletLandingEnterprisesList,
  getLandingEnterprisesDetail,
  addLandingEnterprisesDetail,
  updateLandingEnterprisesDetail,
  getProjectList,
  saveLandingWay,
  checkCommercialCompany,
  delLandingWay,
  submitLandingWay
}



// WEBPACK FOOTER //
// ./src/area-contract/api/regionService.js